import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer>
      <div className="container">
        <div className="footer-container">
          <div className="footer-col">
            <h3>Empower Future 21 (EF21)</h3>
            <p>A women-led Myanmar humanitarian and development organization strengthening education and community resilience alongside conflict-affected communities.</p>
            <p className="footer-tagline">Locally Led. Community-Centred. Evidence-Driven.</p>
          </div>
          
          <div className="footer-col">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/what-we-do">What We Do</Link></li>
              <li><Link to="/goals">Our Goals</Link></li>
              <li><Link to="/activities">Our Work</Link></li>
              <li><Link to="/careers">Join Our Team</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          
          <div className="footer-col">
            <h3>Contact Us</h3>
            <ul>
              <li>Email: <a href="mailto:contact@empowerfuture21.org">contact@empowerfuture21.org</a></li>
            </ul>
          </div>
        </div>
        
        <div className="copyright">
          <p>&copy; {currentYear} Empower Future 21 (EF21). All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;